<template>
  <v-card class="list-change-modal">
    <div class="list-change-modal__header">
      <div class="list-change-modal__title-wrap">
        <div class="list-change-modal__icon-wrap">
          <v-icon class="list-change-modal__icon">mdi-cog-outline</v-icon>
        </div>
        <h2 class="list-change-modal__title">Что хотите изменить?</h2>
      </div>
      <v-btn
        icon
        class="list-change-modal__close"
        @click="close"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <v-card-text class="list-change-modal__body">
      <p v-if="selectedDoorphone.length" class="list-change-modal__hint text-body-2 mb-3 mt-2">
        Выбрано домофонов: <strong>{{ selectedDoorphone.length }}</strong>
      </p>
      <v-list class="list-change-modal__list" dense>
        <ring-sound
          v-if="$checkPermission('mass_upload_ring_sound_doorphone')"
          v-bind:doorphones="selectedDoorphone"
        />
        <text-message
          v-if="$checkPermission('mass_update_text_doorphone')"
          v-bind:doorphones="selectedDoorphone"
        />
        <admin-code
          v-if="$checkPermission('mass_update_code_main_setups')"
          v-bind:doorphones="selectedDoorphone"
        />
        <universal-key
          v-if="$checkPermission('mass_attach_key')"
          v-bind:doorphones="selectedDoorphone"
        />
        <concierge-number
          v-if="$checkPermission('mass_update_concierge_number_main_setups')"
          v-bind:doorphones="selectedDoorphone"
        />
        <ntp-address
          v-if="$checkPermission('mass_set_ntp_address')"
          v-bind:doorphones="selectedDoorphone"
        />
        <toggle-auto-key-collection
          v-if="$checkPermission('mass_toggle_auto_key_collection')"
          v-bind:doorphones="selectedDoorphone"
        />
        <settings-lsd
          v-if="$checkPermission('mass_set_lcd_settings')"
          v-bind:doorphones="selectedDoorphone"
          @redirect-new-page="goToLcdImagePage"
        />
        <sound-settings-door-opening
          v-if="$checkPermission('mass_set_sound_settings_doorphone')"
          v-bind:doorphones="selectedDoorphone"
          @redirect-new-page="goToOpenDoorSoundPage"
        />
        <sound-settings
          v-if="$checkPermission('mass_set_sound_settings_doorphone')"
          v-bind:doorphones="selectedDoorphone"
        />
        <reboot
          v-if="$checkPermission('mass_reboot_doorphone')"
          v-bind:doorphones="selectedDoorphone"
        />
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import RingSound from '@/components/massFunction/components/RingSound';
import TextMessage from '@/components/massFunction/components/TextMessage';
import AdminCode from '@/components/massFunction/components/AdminCode';
import UniversalKey from '@/components/massFunction/components/UniversalKey';
import ConciergeNumber from '@/components/massFunction/components/ConciergeNumber';
import ntpAddress from '@/components/massFunction/components/ntpAddress';
import SettingsLsd from '@/components/massFunction/components/SettingsLsd.vue';
import SoundSettings from '@/components/massFunction/components/SoundSettings';
import ToggleAutoKeyCollection from '@/components/massFunction/components/ToggleAutoKeyCollection';
import Reboot from '@/components/massFunction/components/Reboot';
import SoundSettingsDoorOpening from '@/components/massFunction/components/SoundSettingsDoorOpening';
import { mapGetters } from 'vuex';

export default {
  name: 'ListChangeModal',
  components: {
    RingSound,
    TextMessage,
    AdminCode,
    UniversalKey,
    ConciergeNumber,
    ntpAddress,
    SettingsLsd,
    SoundSettings,
    SoundSettingsDoorOpening,
    ToggleAutoKeyCollection,
    Reboot,
  },
  props: {
    selectedDoorphone: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    valid: true,
  }),
  computed: {
    ...mapGetters({
      roleName: 'roleName',
    }),
  },
  methods: {
    close () {
      this.$emit('close');
      this.$emit('update:active', false);
    },
    goToOpenDoorSoundPage () {
      this.close();
      this.$router.push({ name: 'MassOpenDoorSound' });
    },
    goToLcdImagePage () {
      this.close();
      this.$router.push({ name: 'MassOpenDoorSound', query: { tab: 'image' } });
    },
  },
};
</script>

<style lang="scss" scoped>
.list-change-modal {
  border-radius: 12px;
  overflow: hidden;
}

.list-change-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px;
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 50%, #1e88e5 100%);
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.25);
}

.list-change-modal__title-wrap {
  display: flex;
  align-items: center;
  gap: 14px;
}

.list-change-modal__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
}

.list-change-modal__icon {
  font-size: 26px;
  color: #fff;
}

.list-change-modal__title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #fff;
  margin: 0;
  letter-spacing: -0.01em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.list-change-modal__close {
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.9);
}

.list-change-modal__close:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.15);
}

.list-change-modal__body {
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
}

.list-change-modal__hint {
  color: #546e7a;
}

.list-change-modal__list {
  padding: 0;
}

.list-change-modal__list ::v-deep .v-list-item {
  padding-left: 0;
  padding-right: 0;
  min-height: 48px;
}

.list-change-modal__list ::v-deep .v-list-item:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.list-change-modal__list ::v-deep .v-list-item-content {
  padding-top: 8px;
  padding-bottom: 8px;
}

.list-change-modal__list ::v-deep .v-list-item-action {
  margin-left: 12px;
}
</style>
